import { entity, persistence } from "simpler-state"

/**
 * Per-user, per-browser preference (localStorage): when true the sidebar stays a static
 * collapsed rail — it never expands on hover and pinning is ignored. For users who
 * dislike the expanding sidebar. Toggled from Settings → Preferences.
 */
export const SidebarExpandDisabledState = entity<boolean>(false, [persistence("sidebar_expand_disabled")])
